import Notifications from "entities/Notifications";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "shared/components/Header";
import { NAME_SPACES } from "shared/locales/constants";
import View from "./View";

const List = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.NOTIFICATION);
  const LIST = t("LIST", { returnObjects: true });
  const [pagination, setPagination] = useState({});
  const filter = {};

  return (
    <>
      <Header title={LIST.TITLE} />
      <Notifications
        View={View}
        filter={{ ...filter, ...pagination }}
        setValues={setPagination}
        skip={pagination.skip || 0}
        NoData={View}
      />
    </>
  );
};

export default List;
